import { render, staticRenderFns } from "./ServiceDomainModal.vue?vue&type=template&id=70f1b679&scoped=true"
import script from "./ServiceDomainModal.vue?vue&type=script&lang=js"
export * from "./ServiceDomainModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceDomainModal.vue?vue&type=style&index=0&id=70f1b679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f1b679",
  null
  
)

export default component.exports